export default __webpack_public_path__ + "static/media/payment-method-card.06231e9c.svg";